export const MAX_ATTACHMENT_SIZE_BYTES = 100 * 1024 * 1024;
export const MAX_ATTACHMENT_SIZE_MB = 100;
export const MAX_MANAGED_IMAGE_SIZE_BYTES = 5 * 1024 * 1024;
export const MAX_MANAGED_IMAGE_SIZE_MB = 5;
export const MAX_COMPANY_LOGO_SIZE_BYTES = MAX_MANAGED_IMAGE_SIZE_BYTES;
export const MAX_COMPANY_LOGO_SIZE_MB = MAX_MANAGED_IMAGE_SIZE_MB;
export const MAX_ATTACHMENT_SIZE_ERROR_MESSAGE = 'Attachment size exceeds the 100MB limit.';
export const MAX_ATTACHMENT_SIZE_FIELD_DESCRIPTION = 'Maximum file size: 100MB.';
export const MAX_MANAGED_IMAGE_SIZE_ERROR_MESSAGE = 'Image size exceeds the 5MB limit.';
export const MAX_MANAGED_IMAGE_SIZE_FIELD_DESCRIPTION = 'Maximum image file size: 5MB.';
export const MAX_COMPANY_LOGO_SIZE_ERROR_MESSAGE = MAX_MANAGED_IMAGE_SIZE_ERROR_MESSAGE;
export const MAX_COMPANY_LOGO_SIZE_FIELD_DESCRIPTION = 'Maximum logo file size: 5MB.';
export const ALLOWED_MANAGED_IMAGE_CONTENT_TYPES = ['image/jpeg', 'image/png', 'image/svg+xml', 'image/webp'];
export const ALLOWED_MANAGED_IMAGE_CONTENT_TYPE_SET = new Set(ALLOWED_MANAGED_IMAGE_CONTENT_TYPES);
export const ALLOWED_COMPANY_LOGO_CONTENT_TYPES = ALLOWED_MANAGED_IMAGE_CONTENT_TYPES;
export const ALLOWED_COMPANY_LOGO_CONTENT_TYPE_SET = ALLOWED_MANAGED_IMAGE_CONTENT_TYPE_SET;
export const FILE_EXTENSION_BY_CONTENT_TYPE = {
    'application/json': 'json',
    'application/msword': 'doc',
    'application/octet-stream': 'bin',
    'application/pdf': 'pdf',
    'application/vnd.ms-excel': 'xls',
    'application/vnd.ms-powerpoint': 'ppt',
    'application/vnd.openxmlformats-officedocument.presentationml.presentation': 'pptx',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': 'xlsx',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document': 'docx',
    'application/zip': 'zip',
    'image/gif': 'gif',
    'image/jpeg': 'jpg',
    'image/png': 'png',
    'image/svg+xml': 'svg',
    'image/webp': 'webp',
    'text/csv': 'csv',
    'text/plain': 'txt',
    'video/mp4': 'mp4',
    'video/quicktime': 'mov',
};
